import { render, staticRenderFns } from "./InitialTrainingForm.vue?vue&type=template&id=01a81f30&scoped=true&"
import script from "./InitialTrainingForm.vue?vue&type=script&lang=js&"
export * from "./InitialTrainingForm.vue?vue&type=script&lang=js&"
import style0 from "./InitialTrainingForm.vue?vue&type=style&index=0&id=01a81f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a81f30",
  null
  
)

export default component.exports